import { heroEquipment } from "../HeroEquipment";

export const mroczne = {
  heroes: {
    Szlachcic: {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 75,
      number: 1,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 5, 5, 3, 3, 2, 6, 1, 9],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: ["Dowódca", "Nienawiść", "Szósty zmysł", "Zasadzka"],
      exp: 20,
      skills: [0, 1, 2, 4, 5],
    },
    "Wieszczka Khaina": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"].Mag,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Czarna magia",
        "Mag (Mroczna Magia)",
        "Nienawiść",
        "Szósty zmysł",
      ],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    Korsarz: {
      id: 2,
      startingEquipment: [
        "Sztylet",
        "Pistolet strzałkowy powtarzalny",
        "Płaszcz z łusek morskiego smoka",
      ],
      cost: 45,
      number: 1,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Handlarz niewolników",
        "Nienawiść",
        "Smokobójca",
        "Szósty zmysł",
        "Zasadzka",
        "Żertwa",
      ],
      exp: 11,
      skills: [0, 1, 4, 5],
    },
    Egzekutor: {
      id: 3,
      startingEquipment: ["Sztylet", "Draich"],
      cost: 50,
      number: 1,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 5, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: ["Nienawiść", "Szósty zmysł", "Zabójczy cios"],
      exp: 11,
      skills: [0, 3, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Wojownik: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 30,
      number: 12,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Nienawiść",
        "Szósty zmysł",
      ],
    },
    Widmo: {
      id: 6,
      startingEquipment: ["Sztylet", "Kusza"],
      cost: 50,
      number: 5,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: [
        "Błyskawiczne przeładowanie",
        "Nienawiść",
        "Ranger",
        "Szósty zmysł",
        "Zasadzka",
        "Zwiadowca",
      ],
    },
    "Wiedźma Khaina": {
      id: 7,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 50,
      number: 3,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"]["Wiedźma"],
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 6, 1, 10],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
      },
      rules: ["Fanatyk","Furia","Głód krwi","Nienawiść","Ochronne tatuaże","Szósty zmysł","Zatruty atak","Żniwiarz"],
    },
    "Jeździec Mroku": {
      id: 8,
      startingEquipment: [
        "Sztylet",
        "Włócznia",
        "Rumak elfów",
        "Siodło & uprząż",
      ],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Mroczni Elfowie z Naggaroth"].Jeździec,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 1, 5, 1, 8],
        Maksymalna: [6, 7, 7, 4, 3, 3, 9, 4, 10],
        "Rumak Elfów": [9, 3, 0, 3, "-", "-", 4, 1, 5],
      },
      rules: [
        "Kawalerzysta",
        "Lekka jazda",
        "Nienawiść",
        "Szósty zmysł",
        "Zasadzka",
      ],
    },
    Harpia: {
      id: 9,
      startingEquipment: ["Broń naturalna (szybki)"],
      cost: 35,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 0, 4, 3, 1, 4, 2, 6],
        Maksymalna: [4, 4, 0, 4, 3, 1, 4, 2, 6],
      },
      rules: ["Głód krwi","Lot","Nadrzewni drapieżcy","Rozmiar rzondzi","Zwierzę"],
    },
    "Mroczny pegaz": {
      id: 10,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [8, 3, 0, 4, 4, 3, 4, 2, 6],
        Maksymalna: [8, 3, 0, 4, 4, 3, 4, 2, 6],
      },
      rules: [
        "Lot",
        "Głód krwi",
        "Krzepki",
        "Potwór",
        "Szarża dzików",
        "Wierzchowiec",
        "Zwierzę",
      ],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Zimnokrwisty: [7, 3, 0, 4, "-", "-", 2, 1, 3],
        "Zimnokrwisty ": [7, 3, 0, 4, "-", "-", 2, 1, 3],
      },
      rules: ["Duży cel", "Głupota", "Machina wojenna", "Rydwan", "Strach"],
    },
    Więźniarka: {
      id: 12,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Zimnokrwisty: [7, 3, 0, 4, "-", "-", 2, 1, 3],
        "Zimnokrwisty ": [7, 3, 0, 4, "-", "-", 2, 1, 3],
      },
      rules: [
        "Duży cel",
        "Głupota",
        "Machina wojenna",
        "Strach",
        "Powóz",
        "Więźniarka",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Mroczni Elfowie z Naggaroth",
  nature: "Zła",
  armyRules: ["Podatek", "Rozrzutność"],
  mercenaries: [
    "Balistyk z Czarnej Arki",
    "Gwardzista",
    "Rycerz na Zimnokrwistym",
  ],
};
